import Button from '../shared/button.js';

export default function NextButton(props) {
  return (
    <div className="next-button-container">
      <Button {...props} className="btn-small" />
    </div>
  );
}
